import {IMessageProvider} from "./PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs";

export enum DimensionType {
    Customer = "Customer",
    Product = "Product",
    Time = "Period",
    PromotionPlan = "Plan",
    CustomerSecondary = "Customer2",
    ProductSecondary = "Product2",
    TimeSecondary = "Period2"
}

export interface IHierarchyNode {
    readonly NodeId: string
    readonly NodeIdUI: string
    readonly NodeName: string
    readonly NodeShortName: string
    readonly NodeLevel: string
    readonly NodeObject?: object
    readonly NodeOrder?: number | string

    ParentId?: string

    // Source Key support,
    //    when HierarchyNode Ids overlap, a generated key is created,
    //    source keys allow us to get the original key
    readonly bHasSourceKey?: boolean
    readonly SourceKey?: number | string
    readonly SourceKeyType?: string
}

export interface IHierarchyLevel {
    readonly LevelId: string,
    readonly LevelName: string
    readonly LevelDepth: number
}

export interface IHierarchyFilterOptions {
    FilterNodeIds?: string[]
    bExcludeChildren?: boolean
    bExcludeParents?: boolean
    TopLevel?:string
    BottomLevel?: string
    PruneToLevels?: string[]
}

export interface IHierarchyChangeEvent {
    hierarchy: IHierarchy
    change: string
}

export interface IHierarchy {
    readonly HierarchyId: string
    readonly HierarchyIdUI: string
    readonly HierarchyName: string

    readonly DimensionType: DimensionType
    readonly bHasSortOrder?: boolean

    readonly OnLoadComplete: Promise<void>
    readonly bLoaded: boolean
    readonly LoadMessageProvider: IMessageProvider

    readonly HierarchyChanged?: BehaviorSubject<IHierarchyChangeEvent>

    //-- API to get Nodes
    getLevels(): IHierarchyLevel[]
    getTopLevelNodes(): IHierarchyNode[]
    getNodesAtLevel(HierarchyLevel: string): IHierarchyNode[]
    getNode(NodeId: string): IHierarchyNode
    getNodes(): IHierarchyNode[]

    getChildren(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId?: string): IHierarchyNode[]
    getParents(nodes: IHierarchyNode[] | IHierarchyNode | string[] | string, levelId?: string): {[NodeId: string]: IHierarchyNode}

}
